// eslint-disable-next-line strict
export default null;